import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { getInfoRestaurant } from './getInfoRestaurant'

dayjs.extend(isBetween)
dayjs.extend(timezone)
dayjs.extend(utc)

const getDateByHourAndMinute = ({ hour, minute, timezone }) => {
  return dayjs().tz(timezone).set('hours', hour).set('minutes', minute)
}

/**
 * Kiểm tra thời gian hiện tại có nằm trong khoảng thời gian hợp lệ hay không dựa trên timezone của nhà hàng chứ không dựa trên timezone của máy.
 * Vì có thể máy set timezone ở Việt Nam. Nhưng nhà hàng lại ở Nhật (timezone Nhật) vì vậy sẽ không hiển thị category nếu dựa trên timezone của máy
 * @param {string} openTime HH:mm-HH:mm (08:00-17:00)
 * @returns boolean
 */
export const isBetweenOpenTime = (openTime) => {
  const { timezone: timezoneRestaurant } = getInfoRestaurant()

  if (openTime.trim().length === 0) return true // Nếu giá trị là chuỗi rỗng => true

  const [timeStart, timeEnd] = openTime.split('-')

  const [hourStart, minuteStart] = timeStart.split(':')

  // Xử lý chuyển đổi thời gian dựa trên timezone của nhà hàng
  const dateStart = getDateByHourAndMinute({
    hour: hourStart,
    minute: minuteStart,
    timezone: timezoneRestaurant,
  })

  const [hourEnd, minuteEnd] = timeEnd.split(':')

  // Xử lý chuyển đổi thời gian dựa trên timezone của nhà hàng
  const dateEnd = getDateByHourAndMinute({
    hour: hourEnd,
    minute: minuteEnd,
    timezone: timezoneRestaurant,
  })

  // So sánh dựa trên timezone của nhà hàng
  return dayjs().tz(timezoneRestaurant).isBetween(dateStart, dateEnd)
}

/**
 * Kiểm tra thời gian hiện tại có nằm trong khoảng thời gian setting hay không
 * @param {string} openTimes khoảng thời gian '08:00-17:00,18:00-22:00' hoặc '08:00-17:00'
 * @returns boolean
 */
export const checkListOpenTime = (openTimes) => {
  if (!openTimes) return true

  const listOpenTime = openTimes.split(',')

  return listOpenTime.some((openTime) => {
    return isBetweenOpenTime(openTime)
  })
}

// Hàm xử lý tính toán số phút còn lại của buffet.
export const calcServingTimeBuffet = (servingEndedAt = '') => {
  const now = dayjs()
  const date = dayjs(servingEndedAt)

  // Trừ thời gian hiện tại
  const difference = date.diff(now, 'minutes', true)

  return Math.ceil(difference) // Làm tròn lên
}
